import { useState, useEffect } from 'react';

const useMedia = () => {
  const [isSmall, setIsSmall] = useState(false);
  const [isMedium, setIsMedium] = useState(false);
  const [isLarge, setIsLarge] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      setIsSmall(screenWidth < 768);
      setIsMedium(screenWidth >= 768 && screenWidth < 1024);
      setIsLarge(screenWidth >= 1024);
    };

    handleResize(); // Initial check

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isSmall, isMedium, isLarge };
};

export default useMedia;